module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "提交评论",
      "width": "40%",
      "center": true,
      "visible": _vm.addVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.addVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "comment-body"
  }, [_c('el-form', {
    ref: "submitForm",
    staticClass: "comment-body-form",
    attrs: {
      "model": _vm.submitData,
      "rules": _vm.validatorRules,
      "label-width": "80px"
    }
  }, [_c('div', {
    staticClass: "comment-body-div"
  }, [_c('el-form-item', {
    attrs: {
      "label": "评论内容",
      "prop": "commentText",
      "size": "medium"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写-评论内容",
      "type": "textarea",
      "maxlength": "200",
      "show-word-limit": "",
      "rows": "2"
    },
    model: {
      value: (_vm.submitData.commentText),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "commentText", $$v)
      },
      expression: "submitData.commentText"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "comment-body-div"
  }, [_c('div', {
    staticClass: "star-item-view"
  }, [_c('div', {
    staticClass: "star-item-title"
  }, [_vm._v("\n            视频评分:\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "star-item-value"
  }, [_c('el-rate', {
    attrs: {
      "colors": _vm.starColors
    },
    model: {
      value: (_vm.submitData.starNum),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "starNum", $$v)
      },
      expression: "submitData.starNum"
    }
  })], 1)])])])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提 交")])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2ed9ed78", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ed9ed78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/main/CommentView.vue
// module id = 1271
// module chunks = 1